export default "__VITE_ASSET__BThFqcYG__"